import React from 'react';
import { Callout } from '@blueprintjs/core';

import ZoneMap from './ZoneMap';
import { boundsExtent } from '../helpers/geo';

import styles from './ZoneDesc.module.scss';

const ZoneSectionMap = ({ zones = [] }) => (
  <>
    <div className={styles.maps}>
      {zones.map(zone => (
        <ZoneMap
          key={zone.id_eae}
          zone={zone}
          color={zone.color}
          extent={boundsExtent(zones)}
        />
      ))}
    </div>
    <Callout icon="info-sign" className={styles.mapPrintInfo}>
      Vous avez la possibilité de modifier l'emprise et le zoom de la carte avant impression.
    </Callout>
  </>
);

export default ZoneSectionMap;
